module.exports = __webpack_public_path__ + "static/img_6549_optimized-9b45910812411d1ea393ea88150eff41.jpg";